import { useIntersectionObserver } from '@vueuse/core';
import { Ref } from '@vue/composition-api';

export function useOnEntry(el: Ref<HTMLElement|null>, callback: VoidFunction, unsupportedCallback?: VoidFunction): void {
	const observer = useIntersectionObserver(
		el,
		([{ isIntersecting }]) => {
			if (!isIntersecting) {
				return;
			}

			observer.stop();
			callback();
		},
	);
	if (!observer.isSupported) {
		if (unsupportedCallback) {
			unsupportedCallback();
		} else {
			callback();
		}
	}
}

export function useOnEveryEntry(el: Ref<HTMLElement|null>, callback: VoidFunction, unsupportedCallback?: VoidFunction): void {
	const observer = useIntersectionObserver(
		el,
		([{ isIntersecting }]) => {
			if (!isIntersecting) {
				return;
			}
			callback();
		},
	);
	if (!observer.isSupported) {
		if (unsupportedCallback) {
			unsupportedCallback();
		} else {
			callback();
		}
	}
}
